import { useEffect, useState, useCallback } from 'react';

const useSessionStorage = (key, initialValue, raw) => {

    const [state, setState] = useState(() => {
        try {
            const sessionStorageValue = sessionStorage.getItem(key);
            //  betBaskets need init when page refresh
            if (typeof sessionStorageValue !== 'string' || key === 'betBaskets') {
                sessionStorage.setItem(key, raw ? String(initialValue) : JSON.stringify(initialValue));
                return initialValue;
            } else {
                return raw ? sessionStorageValue : JSON.parse(sessionStorageValue || 'null');
            }
        } catch {
            return initialValue;
        }
    });

    useEffect(() => {
        try {
            const serializedState = raw ? String(state) : JSON.stringify(state);
            sessionStorage.setItem(key, serializedState);
        } catch {}
    }, [key, state]);

    const updateState = useCallback((updater) => {
        setState(prev => {
            const next = typeof updater === 'function' ? updater(prev) : updater;

                // console.log('updateState betbasket',new Date(),next);

            return next;
        });
    }, []);

    return [state, updateState];
};

export default useSessionStorage;
